import { render, staticRenderFns } from "./treatment-detail-plan.html?vue&type=template&id=1bcbc637&scoped=true&"
import script from "./treatment-detail-plan.js?vue&type=script&lang=js&"
export * from "./treatment-detail-plan.js?vue&type=script&lang=js&"
import style0 from "./treatment-detail-plan.scss?vue&type=style&index=0&id=1bcbc637&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbc637",
  null
  
)

export default component.exports